;(function( $, window, document, undefined )
{
	$.fn.doubleTapToGo = function( params )
	{
		if( !( 'ontouchstart' in window ) &&
			!navigator.msMaxTouchPoints &&
			!navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

		this.each( function()
		{
			var curItem = false;

			$( this ).on( 'click', function( e )
			{
				var item = $( this );
				if( item[ 0 ] != curItem[ 0 ] )
				{
					e.preventDefault();
					curItem = item;
				}
			});

			$( document ).on( 'click touchstart MSPointerDown', function( e )
			{
				var resetItem = true,
					parents	  = $( e.target ).parents();

				for( var i = 0; i < parents.length; i++ )
					if( parents[ i ] == curItem[ 0 ] )
						resetItem = false;

				if( resetItem )
					curItem = false;
			});
		});
		return this;
	};
})( jQuery, window, document );

(function($) {
    $.mobileNav = function() {
        "use strict";
        var toggled = false;
        $('.navigation-toggle').click(function(e) {
            e.preventDefault();
            if (!toggled) {
                toggled = true;
                $('#mobile-navigation').addClass('toggled');
            } else {
                toggled = false;
                $('#mobile-navigation').removeClass('toggled');
            }
        });
        $(window).resize(function() {
            var width = $(window).width();
            if (width > 991) {
                toggled = false;
                $('#mobile-navigation').removeClass('toggled');
            }
        });
    }

    $(document).ready(function() {
        $.mobileNav();
        $('#mobile-navigation ul.nav li:has(ul)' ).doubleTapToGo();
    });
})( jQuery, window, document );
